var _ellipse, _ellipse2, _path, _line, _polyline, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasureDbl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 40,
    viewBox: "0 0 90 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 20,
    rx: 16,
    ry: 12,
    fill: "#c8c8c8",
    stroke: "#8a8a8a",
    strokeWidth: 1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68,
    cy: 20,
    rx: 16,
    ry: 12,
    fill: "#c8c8c8",
    stroke: "#8a8a8a",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 20 H52",
    stroke: "#8a8a8a",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 20,
    x2: 52,
    y2: 20,
    stroke: "#e53935",
    strokeWidth: 2.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "41,16 38,20 41,24",
    fill: "none",
    stroke: "#e53935",
    strokeWidth: 1.5
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "49,16 52,20 49,24",
    fill: "none",
    stroke: "#e53935",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureDbl);
export default __webpack_public_path__ + "static/media/measure_dbl.401838e950a7ac8c7b5e52afdfce797f.svg";
export { ForwardRef as ReactComponent };